import { render, staticRenderFns } from "./CreateNewContact.vue?vue&type=template&id=2fc86992&"
import script from "./CreateNewContact.vue?vue&type=script&lang=js&"
export * from "./CreateNewContact.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewContact.vue?vue&type=style&index=0&id=2fc86992&prod&lang=scss&"
import style1 from "./CreateNewContact.vue?vue&type=style&index=1&id=2fc86992&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports